module.exports = __webpack_public_path__ + "images/aus_meat_ref_trimmed_4fa2e33.png";